import { render } from "./MainHeaderMenuPopup.vue?vue&type=template&id=9221adca&scoped=true"
import script from "./MainHeaderMenuPopup.vue?vue&type=script&lang=js"
export * from "./MainHeaderMenuPopup.vue?vue&type=script&lang=js"

import "./MainHeaderMenuPopup.vue?vue&type=style&index=0&id=9221adca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9221adca"]])

export default __exports__